<template>
  <div>
    <card>
      <h5>Income</h5>
      <p>Registration Income</p>
      <el-table
        :data="budgetDetails.RegistrationIncome"
        header-row-class-name="text-danger text-left"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        class="mb-3"
      >
        <el-table-column
          label="Title"
          min-width="120"
          sortable
          property="Title"
        />
        <el-table-column
          label="Budgeted Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="budgetMathFormatter"
        />
        <el-table-column
          property="ExtendedBudgetAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Budget</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Actual Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="actualMathFormatter"
        />
        <el-table-column
          property="ActualAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Actual</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Difference"
          class-name="d-none d-md-table-cell text-center"
          property="BudgetRemaining"
          :formatter="currencyFormatter"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="60"
          v-if="editable"
          label="Adjust"
        >
          <template slot-scope="props">
            <p-button
              type="info"
              class="mt-1 mb-1"
              size="sm"
              title="Update Budget"
              icon
              @click="showScouterEstimateDialog(props.row)"
            >
              <span style="color:white">$</span>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
      <p>Other Income</p>
      <el-table
        :data="budgetDetails.OtherIncome"
        header-row-class-name="text-danger text-left"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
      >
        <el-table-column
          label="Title"
          min-width="120"
          sortable
          property="Title"
        />
        <el-table-column
          label="Budgeted Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="budgetMathFormatter"
        />
        <el-table-column
          property="ExtendedBudgetAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Budget</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Actual Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="actualMathFormatter"
        />
        <el-table-column
          property="ActualAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Actual</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Difference"
          class-name="d-none d-md-table-cell text-center"
          property="BudgetRemaining"
          :formatter="currencyFormatter"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="60"
          v-if="editable"
          label="Adjust"
        >
          <template slot-scope="props">
            <p-button
              type="info"
              class="mt-1 mb-1"
              size="sm"
              title="Update Budget"
              icon
              @click="showBudgetItemDialog(props.row)"
            >
              <span style="color:white">$</span>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
    </card>
    <card>
      <h5>Expenses</h5>
      <p>Scouter Expenses</p>
      <el-table
        :data="budgetDetails.ScouterExpenses"
        header-row-class-name="text-danger text-left"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        class="mb-3"
      >
        <el-table-column
          label="Title"
          min-width="120"
          sortable
          property="Title"
        />
        <el-table-column
          label="Budgeted Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="budgetMathFormatter"
        />
        <el-table-column
          property="ExtendedBudgetAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Budget</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Actual Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="actualMathFormatter"
        />
        <el-table-column
          property="ActualAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Actual</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Remaining"
          class-name="d-none d-md-table-cell text-center"
          property="BudgetRemaining"
          :formatter="currencyFormatter"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="60"
          v-if="editable"
          label="Adjust"
        >
          <template slot-scope="props">
            <p-button
              type="info"
              class="mt-1 mb-1"
              size="sm"
              title="Update Budget"
              icon
              @click="showBudgetItemDialog(props.row)"
            >
              <span style="color:white">$</span>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
      <p>Administrative Expenses</p>
      <el-table
        :data="budgetDetails.AdminExpenses"
        header-row-class-name="text-danger text-left"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        class="mb-3"
      >
        <el-table-column
          label="Title"
          min-width="120"
          sortable
          property="Title"
        />
        <el-table-column
          label="Budgeted Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="budgetMathFormatter"
        />
        <el-table-column
          property="ExtendedBudgetAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Budget</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Actual Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="actualMathFormatter"
        />
        <el-table-column
          property="ActualAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Actual</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Remaining"
          class-name="d-none d-md-table-cell text-center"
          property="BudgetRemaining"
          :formatter="currencyFormatter"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="60"
          v-if="editable"
          label="Adjust"
        >
          <template slot-scope="props">
            <p-button
              type="info"
              class="mt-1 mb-1"
              size="sm"
              title="Update Budget"
              icon
              @click="showBudgetItemDialog(props.row)"
            >
              <span style="color:white">$</span>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
      <p>Consumable Expenses</p>
      <el-table
        :data="budgetDetails.Consumables"
        header-row-class-name="text-danger text-left"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        class="mb-3"
      >
        <el-table-column
          label="Title"
          min-width="120"
          sortable
          property="Title"
        />
        <el-table-column
          label="Budgeted Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="budgetMathFormatter"
        />
        <el-table-column
          property="ExtendedBudgetAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Budget</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Actual Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="actualMathFormatter"
        />
        <el-table-column
          property="ActualAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Actual</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Remaining"
          class-name="d-none d-md-table-cell text-center"
          property="BudgetRemaining"
          :formatter="currencyFormatter"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="60"
          v-if="editable"
          label="Adjust"
        >
          <template slot-scope="props">
            <p-button
              type="info"
              class="mt-1 mb-1"
              size="sm"
              title="Update Budget"
              icon
              @click="showBudgetItemDialog(props.row)"
            >
              <span style="color:white">$</span>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
      <p>Food Expenses</p>
      <el-table
        :data="budgetDetails.Food"
        header-row-class-name="text-danger text-left"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        class="mb-3"
      >
        <el-table-column
          label="Title"
          min-width="120"
          sortable
          property="Title"
        />
        <el-table-column
          label="Budgeted Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="budgetMathFormatter"
        />
        <el-table-column
          property="ExtendedBudgetAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Budget</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Actual Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="actualMathFormatter"
        />
        <el-table-column
          property="ActualAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Actual</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Remaining"
          class-name="d-none d-md-table-cell text-center"
          property="BudgetRemaining"
          :formatter="currencyFormatter"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="60"
          v-if="editable"
          label="Adjust"
        >
          <template slot-scope="props">
            <p-button
              type="info"
              class="mt-1 mb-1"
              size="sm"
              title="Update Budget"
              icon
              @click="showBudgetItemDialog(props.row)"
            >
              <span style="color:white">$</span>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
      <p>Contingency Reserve</p>
      <el-table
        :data="budgetDetails.Contingencies"
        header-row-class-name="text-danger text-left"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        class="mb-3"
      >
        <el-table-column
          label="Title"
          min-width="120"
          sortable
          property="Title"
        />
        <el-table-column
          label="Budgeted Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="budgetMathFormatter"
        />
        <el-table-column
          property="ExtendedBudgetAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Budget</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Actual Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="actualMathFormatter"
        />
        <el-table-column
          property="ActualAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Actual</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Remaining"
          class-name="d-none d-md-table-cell text-center"
          property="BudgetRemaining"
          :formatter="currencyFormatter"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="60"
          v-if="editable"
          label="Adjust"
        >
          <template slot-scope="props">
            <p-button
              type="info"
              class="mt-1 mb-1"
              size="sm"
              title="Update Budget"
              icon
              @click="showBudgetItemDialog(props.row)"
            >
              <span style="color:white">$</span>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
      <p>Other Expenses</p>
      <el-table
        :data="budgetDetails.OtherExpenses"
        header-row-class-name="text-danger text-left"
        size="small"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        class="mb-3"
      >
        <el-table-column
          label="Title"
          min-width="120"
          sortable
          property="Title"
        />
        <el-table-column
          label="Budgeted Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="budgetMathFormatter"
        />
        <el-table-column
          property="ExtendedBudgetAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Budget</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Actual Amount"
          class-name="d-none d-md-table-cell"
          header-align="right"
          :formatter="actualMathFormatter"
        />
        <el-table-column
          property="ActualAmount"
          :formatter="currencyFormatter"
        >
          <template slot="header">
            <span class="d-block d-md-none">Actual</span>
          </template>
        </el-table-column>
        <el-table-column
          label="Remaining"
          class-name="d-none d-md-table-cell text-center"
          property="BudgetRemaining"
          :formatter="currencyFormatter"
        />
        <el-table-column
          class-name="d-none d-md-table-cell action-buttons td-actions"
          align="right"
          width="60"
          v-if="editable"
          label="Adjust"
        >
          <template slot-scope="props">
            <p-button
              type="info"
              class="mt-1 mb-1"
              size="sm"
              title="Update Budget"
              icon
              @click="showBudgetItemDialog(props.row)"
            >
              <span style="color:white">$</span>
            </p-button>
          </template>
        </el-table-column>
      </el-table>
    </card>
    <scouter-estimates-modal
      v-if="editable"
      :scouter-estimate="scouterEstimate"
      :budget-id="budgetInfo.Budget.Id"
      @budget-info-refreshed="budgetInfoRefreshed"
    />
    <modal
      :show.sync="showEditItem"
      class="modal-primary"
      :show-close="false"
      header-classes="justify-content-center"
      type="mini"
    >
      <div
        slot="header"
        class="ml-4"
      >
        <h6>
          <i class="ti ti-receipt mr-2" /><span class="text-danger">Update Budget Item</span>
        </h6>
      </div>
      <h5><small>{{ editItem.Title }}</small></h5>
      <div
        class="row"
        v-if="editItem.BudgetQuantityType !== 'Quantity'"
      >
        <div class="col-md-4" />
        <div class="col-md-8">
          <div class="row">
            <div class="input-group-prepend">
              <span
                class="input-group-text"
                style="background-color:lightgray"
              >$</span>
            </div>
            <input
              type="number"
              title="Budget Amount"
              v-model="editItem.BudgetAmount"
              min="0"
              step="0.01"
              class="form-control"
              style="width:100px;text-align:right"
              aria-describedby="addon-right addon-left"
            >
            <div
              class="input-group-append"
              v-if="perStatement !== ''"
            >
              <span
                class="input-group-text"
                style="background-color:lightgray"
              >{{ perStatement }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="row"
        v-if="editItem.BudgetQuantityType === 'Quantity'"
      >
        <div class="col-md-12">
          <div class="row">
            <div class="input-group-prepend">
              <span
                class="input-group-text"
                style="background-color:lightgray"
              >Quantity:</span>
            </div>
            <input
              type="number"
              title="Budget Amount"
              v-model="editItem.BudgetQuantity"
              min="0'"
              class="form-control"
              style="width:100px;text-align:right"
              aria-describedby="addon-right addon-left"
            >
            <div class="input-group-append input-group-prepend">
              <span
                class="input-group-text"
                style="background-color:lightgray"
              >at $</span>
            </div>
            <input
              type="number"
              title="Budget Amount"
              v-model="editItem.BudgetAmount"
              min="0"
              step="0.01"
              class="form-control"
              style="width:100px;text-align:right"
              aria-describedby="addon-right addon-left"
            >
            <div class="input-group-append">
              <span
                class="input-group-text"
                style="background-color:lightgray"
              >each</span>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <p-button
          type="danger"
          class="mr-2"
          @click="showEditItem = false"
        >
          Cancel
        </p-button>
        <p-button
          type="success"
          class="mr-2"
          @click="saveDetailItem"
        >
          Save
        </p-button>
      </template>
    </modal>
  </div>
</template>

<script>
import formatter from '@/services/formatter.js'
import ScouterEstimatesModal from '@/components/finance/modals/scouter-estimates.vue'
import budgetApi from '@/services/api/budget.js'
import Modal from '@/plugins/paper-components/modal.vue'

export default {
  name: 'BudgetDetails',
  components: {
    ScouterEstimatesModal,
    Modal
  },
  props: {
    editable: {
      type: Boolean,
      default: null
    },
    budgetInfo: {
      type: Object,
      default: function () {
        return {
          Budget: {}
        }
      }
    }
  },
  data: function () {
    return {
      cellStyle: { padding: '0', height: '20px', 'font-size': '10px' },
      headerCellStyle: { padding: '0', height: '20px', 'font-size': '10px', 'word-break': 'normal' },
      loading: true,
      errormessage: null,
      scouterEstimate: {
        show: false,
        participants: null,
        staff: null
      },
      budgetDetails: {},
      showEditItem: false,
      editItem: {},
      tempHolding: null
    }
  },
  computed: {
    perStatement: function () {
      if (this.editItem.BudgetQuantityType === 'Participant') {
        return 'per participant'
      } else if (this.editItem.BudgetQuantityType === 'StaffMember') {
        return 'per staff member'
      } else if (this.editItem.BudgetQuantityType === 'Course Day') {
        return 'per course day'
      } else if (this.editItem.BudgetQuantityType === 'Scouter') {
        return 'per scouter'
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.refreshDetails()
  },
  methods: {
    refreshDetails: function () {
      budgetApi.getBudgetCategoryWithDetails(this.$root.courseKey)
        .then(x => {
          this.budgetDetails = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveDetailItem: function () {
      if (this.editItem.BudgetAmount === null || isNaN(this.editItem.BudgetAmount)) {
        this.editItem.BudgetAmount = 0
      }

      const newBi = {
        Id: this.editItem.BudgetItemId,
        BudgetId: this.editItem.BudgetId,
        Title: this.editItem.Title,
        BudgetCategory: this.editItem.BudgetCategory,
        CatalogNumber: this.editItem.CatalogNumber,
        Quantity: this.editItem.BudgetQuantity,
        Amount: this.editItem.BudgetAmount,
        BudgetQuantityType: this.editItem.BudgetQuantityType
      }

      budgetApi.updateBudgetItem(newBi, this.$root.courseKey)
        .then(x => {
          this.budgetDetails = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error saving your budget line item.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .finally(() => {
          this.$emit('details-updated')
          this.showEditItem = false
        })
    },
    currencyFormatter: function (row, column, cellValue, index) {
      return formatter.formatAsCurrency(cellValue, 2)
    },
    budgetMathFormatter: function (row, column, cellValue, index) {
      this.tempHolding = { r: row, c: column, cv: cellValue, i: index }
      let returnValue = ''

      switch (row.BudgetQuantityType) {
        case 'Participant':
          returnValue = this.budgetInfo.Budget.EstimatedParticipants + ' participants x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'StaffMember':
          returnValue = this.budgetInfo.Budget.EstimatedStaff + ' staff members x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'CourseDay':
          returnValue = '5 days x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'Quantity':
          returnValue = row.BudgetQuantity + ' x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        case 'Scouter':
          var scouters = this.budgetInfo.Budget.EstimatedParticipants + this.budgetInfo.Budget.EstimatedStaff
          returnValue = scouters + ' scouters x ' + formatter.formatAsCurrency(row.BudgetAmount, 2)
          break
        default:
          break
      }
      return returnValue
    },
    actualMathFormatter: function (row, column, cellValue, index) {
      this.tempHolding = { r: row, c: column, cv: cellValue, i: index }
      let returnValue = ''

      switch (row.BudgetQuantityType) {
        case 'Participant':
          returnValue = this.budgetInfo.Budget.ParticipantCount + ' participants'
          break
        case 'StaffMember':
          returnValue = this.budgetInfo.Budget.StaffCount + ' staff members'
          break
        case 'Scouter':
          var scouters = this.budgetInfo.Budget.ParticipantCount + this.budgetInfo.Budget.StaffCount
          returnValue = scouters + ' scouters'
          break
        default:
          break
      }
      return returnValue
    },
    showScouterEstimateDialog: function (row) {
      this.scouterEstimate.participants = this.budgetInfo.Budget.EstimatedParticipants
      this.scouterEstimate.staff = this.budgetInfo.Budget.EstimatedStaff
      this.scouterEstimate.show = true
    },
    showBudgetItemDialog: function (row) {
      this.editItem = row
      this.showEditItem = true
    },
    budgetInfoRefreshed: function (newBudgetInfo) {
      this.refreshDetails()
      this.$emit('budget-updated', newBudgetInfo)
      this.$notify({
        message: 'Update Complete',
        icon: 'nc-icon nc-satisfied',
        type: 'success',
        horizontalAlign: 'center',
        timeout: 2000
      })
    }
  }
}
</script>
<style scoped>
.cell {
  word-break: normal !important;
}
</style>
